import { getSettingsCompany } from '@/services/settings';
import { validateLogo } from '../regex';

export const getImage = async (id: string) => {
  const url = await getSettingsCompany(id)();
  if (validateLogo.test(url.logo)) {
    return url.logo;
  }
  const data = await fetch(url.logo);
  const blob = await data.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
    reader.onerror = reject;
  });
};

export const ticketTemplate = (impression: object | any, img: string) => `
<div
  style="
    width: 100%;
    height: 100%;
    padding: 8px;
    background: white;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    display: inline-flex;
  "
>
  <div
    style="
      align-self: stretch;
      height: 15px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      display: flex;
      margin-bottom: 10rem;
    "
  >
    <img
      style="
        width: 7rem;
        height: 7rem;
      "
      src="${img}"
    />
    <div
      style="
        width: 181px;
        height: 15px;
        text-align: center;
        color: black;
        font-size: 15px;
        font-family: Monospace;
        font-weight: 700;    
        word-wrap: break-word;
      "
    >
      Factura Venta POS
    </div>
    <div
      style="
        width: 181px;
        height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
      "
    >
      ${impression?.company}
    </div>
    <div
      style="
        width: 181px;
        height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
      "
    >
      ${impression?.nit}
    </div>
  </div>

  <div
    style="
      align-self: stretch;
      min-height: 59px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: flex;
    "
  >
    <div
      style="
        align-self: stretch;
        height: 17px;
        color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      <p
        style="
          display: block;
          margin: 10px;
          color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
        "
      >
        Orden: ${impression?.id}
      </p>
    </div>

    <div
      style="
        align-self: stretch;
        height: 17px;
        color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      <p
        style="
          display: block;
          margin: 10px;
          color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
        "
      >
        Factura de venta: POS No. ${impression?.countFacture}
      </p>
    </div>

    <div
      style="
        align-self: stretch;
        height: 17px;
        color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      <p
        style="
          display: block;
          margin: 10px;
          color: black;
        font-size: 16px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
        "
      >
        Fecha: ${impression?.date}
      </p>
    </div>
  </div>


  <div
    style="
      display: flex;
      align-self: stretch;
      height: 20px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    "
  >
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
    <div
      style="
        margin-left: 0.7rem;
        text-align: center;
        color: black;
        font-size: 15px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      Mesa: ${impression?.table}
    </div>
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  </div>

  <div
    style="
      display: flex;
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 0px;

    "
  >
    <table>
      <thead>
       <tr style="display: flex; align-items: center;">
  <td style="flex: 0 0 auto; width: 30px; font-size: 13px; font-family: Monospace; font-weight: 700; color: black;">
    Unit
  </td>
  <td style="flex: 1 1 auto; font-size: 13px; font-family: Monospace; font-weight: 700; color: black; padding-left: 1rem;">
    Producto
  </td>
  <td style="flex: 0 0 auto; width: 100px; font-size: 13px; font-family: Monospace; font-weight: 700; color: black; padding-left: 3.5rem; text-align: left;">
    Precio
  </td>
</tr>
      </thead>

      <tbody>
        ${impression?.products
          .map(
            (product: object | any) => `
       <tr style="display: flex; align-items: flex-start;">
  <td style="flex: 0 0 auto; width: 30px; font-size: 13px; font-family: Monospace; font-weight: 700; color: black;">
    ${product.quantity}
  </td>
  <td style="flex: 1; display: flex; align-items: flex-start;">
    <div style="flex: 1 1 auto; max-width: 300px; font-size: 13px; font-family: Monospace; font-weight: 700; color: black; padding-left: 1rem; white-space: normal; overflow: hidden; text-overflow: ellipsis;">
   ${product.name}
    </div>
    <div style="flex: 0 0 auto; width: 100px; font-size: 13px; font-family: Monospace; font-weight: 700; color: black; text-align: left; padding-left: 1rem;">
   ${product.priceWithoutDiscount}
    </div>
  </td>
</tr>

        `
          )
          .join('')}

      </tbody>
    </table>
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  </div>

  <div
    style="
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      gap: 4px;
      display: flex;
    "
  >
    <div
      style="
        display: flex;
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      margin-left: 0px;
      font-size: 15px;
      "
    >
      Ctd items: ${impression?.totalItems}
    </div>
  </div>

  <div
    style="
      align-self: stretch;
      height: 15px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      display: flex;
      margin:7px

    "
  >
    <div
      style="
        width: 181px;
        min-height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;    
        word-wrap: break-word;
      "
    >
      Detalles Impuestos
    </div>
  </div>
  <div
  style="
    align-self: stretch;
    min-height: 59px;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    display: flex;
  "
>
  <div
  style="
      display: flex;
      align-self: stretch;
      min-height: 25px;
      color: black;
      font-size: 13px;
      font-family: Monospace;
      font-weight: 700;
      word-wrap: break-word;
      flex-direction: row;
      justify-content: space-between;
      margin-right: 2rem;
      margin-top:7px

      
    "
  >
    <div>
      Subtotal
    </div>
    <div>
      ${impression?.base}
    </div>
  </div>

    ${
      impression?.taxes !== '$0'
        ? `<div
          style="
            align-self: stretch;
            min-height: 25px;
            color: black;
            font-size: 13px;
            font-family: Monospace;
            font-weight: 700;
            word-wrap: break-word;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            margin-right: 2rem;
          "
        >
          <div>
            IMPTO. NAL. CONSUMO
          </div>
          <div>
            ${impression?.taxes}
          </div>
        </div>`
        : ''
    }
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  </div>

  <div
    style="
      align-self: stretch;
      height: 15px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 4px;
      display: flex;
    "
  >
    <div
      style="
        width: 181px;
        height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;    
        word-wrap: break-word;}
      margin-top:0px

      "
    >
      General
    </div>
  </div>

  <div
    style="
      display: flex;
      align-self: stretch;
      min-height: 59px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      
    "
  >
    ${
      impression?.subtotal !== '$0' &&
      `<div
        style="
          align-self: stretch;
          min-height: 25px;
          color: black;
          font-size: 13px;
          font-family: Monospace;
          font-weight: 700;
          word-wrap: break-word;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-right: 2rem;
        "
      >
        <div>
          Base
        </div>
        <div>
          ${impression?.subtotal}
        </div>
      </div>`
    }

    <div
    style="
      align-self: stretch;
      min-height: 25px;
      color: black;
      font-size: 13px;
      font-family: Monospace;
      font-weight: 700;
      word-wrap: break-word;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin-right: 2rem;
    "
  >
    <div>
      Descuento
    </div>
    <div>
      ${impression?.discount}
    </div>
  </div>

 
  

    <div
      style="
        align-self: stretch;
        min-height: 25px;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-right: 2rem;
      "
    >
      <div>
        Total
      </div>
      <div>
      ${impression?.totalFacture}

      </div>
    </div>
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  </div>

  <div
    style="
      align-self: stretch;
      min-height: 59px;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: flex;
    "
  >
    ${
      impression?.tips !== '$0' &&
      `<div
        style="
          align-self: stretch;
          min-height: 25px;
          color: black;
          font-size: 13px;
          font-family: Monospace;
          font-weight: 700;
          word-wrap: break-word;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-right: 2rem;
        "
      >
        <div>
          Propina: (Sugerido 10%)
        </div>
        <div>
          ${impression?.tips}
        </div>
      </div>`
    }  

    <div
      style="
        align-self: stretch;
        min-height: 25px;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        word-wrap: break-word;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-right: 2rem;
      "
    >
      <div>
        Total Factura
      </div>
      <div>
      ${impression?.total}

      </div>
    </div>
    <div
      style="
        align-self: stretch;
        height: 0px;
        border: 0;
        border-top: 1px dashed #111;
      "
    ></div>
  </div>

  <div
    style="
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      display: flex;
    "
  >
    <div
      style="
        width: 181px;
        min-height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      RESOLUCION DIAN ${impression?.resolution}
    </div>
    <div
      style="
        width: 181px;
        height: auto;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      DESDE ${impression?.initialNumberResolution} HASTA ${impression?.maxQuantityResolution} 
    </div>
    <div
      style="
        width: 181px;
        min-height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
      "
    >
      DEL ${impression?.dateResolution}
    </div>
    <div
      style="
        width: 181px;
        min-height: 15px;
        text-align: center;
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;        
        word-wrap: break-word;
        margin-bottom: 20px;
      "
    >
      VIGENCIA ${impression?.expireInMonths} MESES
    </div>
    <div
      style="
        color: black;
        font-size: 13px;
        font-family: Monospace;
        font-weight: 700;
        align-self: stretch;
        min-height: 59px;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        display: flex;
        width: 23.1rem;
      "
    >
      ATENCION : Luego de pagada la factura, si tiene un reclamo y su pago fue mediante tarjeta de credito, NO SE HACEN DEVOLUCIONES
    </div>
  </div>
</div>`;
